import React, { useState, useRef, useEffect } from 'react';
import css from './AlertBanner.module.scss';
import cn from 'classnames';

const BANNER_URL = 'https://www.producthunt.com/posts/sharetribe-2';

const AlertBanner = ({ active }) => {
  const bannerRef = useRef();
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const scrollPosition = window.scrollY;
      if (bannerRef.current) {
        if (scrollPosition > 50) {
          setIsScrolled(true);
        } else {
          setIsScrolled(false);
        }
      }
    };

    onScroll();

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (active) {
    return (
      <a
        ref={bannerRef}
        href={BANNER_URL}
        target="_blank"
        rel="noreferrer"
        className={cn(css.wrapper, { [css.isScrolled]: isScrolled })}
      >
        We're living on Product Hunt right now 🚀 Please support us there, ask a question or give
        feedback!
      </a>
    );
  }

  return null;
};

export default AlertBanner;
